import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as moment from "moment-timezone";
import { Moment } from "moment-timezone";

export const minDateValidator = (minDate: Moment): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
        if (minDate && control.value) {
            const singleDateIsInvalid = moment.isMoment(control.value) && control.value.isBefore(minDate);
            const rangeIsInvalid = control.value.start && control.value.start.isBefore(minDate);
            if (singleDateIsInvalid || rangeIsInvalid) {
                return {
                    minDate: {
                        spsLabelErrorMessage: "Selected date is prior to the earliest allowed date."
                    }
                };
            }
        }
        return null;
    };
